export default {"src":"/_next/static/media/parsnips.e13a1413.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};